// Neo's status on home (TOM-512; handoff "Neo status"), in home's fixed
// header since TOM-683, so scrolling the board never moves it: the body, and
// at most one thing to watch. The owner can dismiss it (`onDismiss`); home
// hides it until Neo writes something else (homeStatusDismiss). The headline
// and the time ("Neo · 8:42 PM · …") are in home's header (TOM-526), so the
// block goes on from them with no label of its own, and with nothing to add
// it draws nothing. The words come composed from the cloud (TOM-509) in the
// reader's units and on the boat's clock; this only draws them.
//
// Tone `unknown` (the boat has gone quiet, or there is nothing to go on yet)
// is drawn neutral, never as calm: its line is true and the owner needs it
// most when the boat is silent (the manager session's decision, 2026-10-08,
// the same on the web and in the app). Only a failed read draws nothing.

import type { NeoStatus } from '@neomaris/protocol';

import { Icon } from '../ui/Icon';

export function NeoStatusBlock({
  status,
  onDismiss,
}: {
  status: NeoStatus;
  onDismiss?: () => void;
}) {
  const watch = status.watch;
  if (status.body.length === 0 && watch === null) return null;
  return (
    <section
      className={`neo-status neo-status--${status.tone}${onDismiss ? ' neo-status--dismissible' : ''}`}
      aria-label="Neo's status"
      data-testid="neo-status"
      data-tone={status.tone}
    >
      {status.body.length > 0 ? (
        <div className="neo-status__text">
          <p className="neo-status__body" data-testid="neo-status-body">
            {status.body}
          </p>
        </div>
      ) : null}
      {watch !== null ? (
        <div
          className={`neo-status__watch neo-status__watch--${watch.tone}`}
          data-testid="neo-status-watch"
          data-key={watch.key}
          data-tone={watch.tone}
        >
          <span className="neo-status__watch-icon" aria-hidden="true">
            <Icon name={watch.icon} size={22} />
          </span>
          <span className="neo-status__watch-text">
            <span className="neo-status__watch-title">{watch.title}</span>
            <span className="neo-status__watch-body">{watch.body}</span>
          </span>
        </div>
      ) : null}
      {onDismiss ? (
        <button
          type="button"
          className="tb-icon-btn neo-status__dismiss"
          aria-label="Dismiss Neo's status"
          title="Dismiss"
          data-testid="neo-status-dismiss"
          onClick={onDismiss}
        >
          <Icon name="x" size={16} />
        </button>
      ) : null}
    </section>
  );
}
